export default __webpack_public_path__ + "static/media/Albino Pheasant.7e73caed.jpg";